var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IDEs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "p5js-IDE-styles-foundation-pt-2",
    transform: "translate(-425.000000, -1168.000000)",
    fill: "#AAA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(16.000000, 1063.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow-shape-copy-2",
    transform: "translate(416.000000, 109.198314) rotate(-180.000000) translate(-416.000000, -109.198314) ",
    points: "417.4 106.396628 423 111.996628 421.6 113.396628 416 107.796628 410.4 113.396628 409 111.996628 414.6 106.396628 415.996628 105"
  }))))));
};
export default SvgDownArrow;